import { lastDigits } from '@/utils';

const renderTicketBadge = (value: string | null | undefined) => {
  if (value == null) return null;
  return (
    <div
      style={{
        backgroundColor: '#2E7D32',
        color: '#FFFFFF',
        borderRadius: '4px',
        padding: '2px 6px',
        fontSize: '0.85rem',
        fontWeight: 'bold',
        textAlign: 'center',
        minWidth: '28px',
        display: 'inline-block',
      }}
    >
      {lastDigits(value)}
    </div>
  );
};

export default renderTicketBadge;
